import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center","color":"white"} }

import { computed, onMounted, ref, watch } from 'vue'
import * as echarts from 'echarts'
import { colorArray as chartColors } from './config'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    default: '-',
  },
  value: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props

const chart = ref()

watch(
  () => props.value,
  (newData) => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.setOption({
          title: {
            text: `${newData.toFixed(2)}%`,
          },
          series: [
            {
              data: [
                {
                  value: newData,
                  itemStyle: {
                    color: '#6563ff',
                  },
                },
                {
                  value: 100 - newData,
                  itemStyle: {
                    color: '#eef2f8',
                  },
                },
              ],
            },
          ],
        })
      }
    }
  },
  { immediate: true, deep: true },
)

onMounted(() => {
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
// ECharts 配置
const chartOption = computed(() => ({
  color: chartColors,
  title: {
    text: `${props.value}%`,
    left: 'center',
    top: 'center', // 居中显示
    textStyle: {
      fontSize: 18,
      color: '#6563ff',
      fontWeight: 'bold',
    },
    subtextStyle: {
      fontSize: 10,
      color: '#909399',
    },
  },
  series: [
    {
      type: 'pie',
      radius: ['75%', '90%'],
      center: ['50%', '50%'], // 居中
      avoidLabelOverlap: false,
      hoverAnimation: false,
      label: {
        show: false,
      },
      data: [
        {
          value: props.value,
          itemStyle: {
            color: '#6563ff',
          },
        },
        {
          value: 100 - props.value,
          itemStyle: {
            color: '#eef2f8',
          },
        },
      ],
    },
  ],
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "chart",
      ref: chart,
      style: {"width":"100%","height":"100%"}
    }, null, 512),
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.name), 1)
  ]))
}
}

})